import styled from "styled-components";

export const ContentDrawer = styled.div`
  font-family: "Poppins", sans-serif;
  padding: 0.25rem 0 0.5rem;
  color: #0e2244;

  .field-label {
    display: block;
    font-size: 0.78rem;
    font-weight: 600;
    color: #0e2244;
    margin: 0 0 0.3rem;
  }

  .field-block {
    margin-bottom: 1.5rem;
  }

  .section-title {
    font-size: 0.8rem;
    font-weight: 600;
    color: #0e2244;
    margin: 0.2rem 0 0.35rem;
  }

  .sub-label {
    font-size: 0.72rem;
    color: #666;
    margin: 0 0 0.25rem;
  }

  .operation-toggles {
    display: flex;
    width: 100%;
    border: 1px solid rgba(14, 34, 68, 0.15);
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 0.15rem;
  }

  .operation-chip {
    flex: 1;
    border: none;
    border-right: 1px solid rgba(14, 34, 68, 0.12);
    background: rgba(121, 121, 133, 0.08);
    color: #0e2244;
    padding: 0.55rem 0.4rem;
    font-family: "Poppins", sans-serif;
    font-size: 0.8rem;
    font-weight: 500;
    cursor: pointer;
    transition:
      background 0.15s,
      color 0.15s;

    &:last-child {
      border-right: none;
    }

    &:hover {
      background: rgba(14, 34, 68, 0.08);
    }

    &.active {
      background: var(--background-button-component, #0e2244);
      color: #fff;
    }
  }

  .range {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;

    input {
      width: 125px;
      height: 2.25rem;
      border: 1px solid rgba(14, 34, 68, 0.18);
      border-radius: 8px;
      padding: 0 0.4rem;
      font-family: "Poppins", sans-serif;
      font-size: 0.78rem;
      text-align: center;
      background: #fff;
    }

    .range-slider {
      flex: 1;
    }
  }

  .types-switch-list {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    margin-top: 0.15rem;
  }

  .type-switch-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.35rem 0.4rem;
    margin: 0 -0.4rem;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s;

    &:hover {
      background: rgba(14, 34, 68, 0.04);
    }

    span {
      font-size: 0.85rem;
      color: #0e2244;
      font-weight: 500;
    }
  }

  .room-single {
    margin-bottom: 1.5rem;

    .bullets {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
    }

    .bullet-single {
      flex: 1 1 calc(16.66% - 0.5rem);
      min-width: 2.2rem;
      text-align: center;
      border: none;
      border-radius: 8px;
      padding: 0.5rem 0.5rem;
      font-size: 0.8rem;
      font-weight: 500;
      font-family: "Poppins", sans-serif;
      cursor: pointer;
      user-select: none;
      background: rgba(121, 121, 133, 0.1);
      color: #0e2244;
      transition:
        background 0.15s,
        color 0.15s;

      &.clicked {
        background: var(--background-button-component, #0e2244);
        color: #fff;
      }
    }

    .large-bullet-single {
      width: 100%;
      text-align: center;
      border: none;
      border-radius: 8px;
      padding: 0.5rem 0.5rem;
      font-size: 0.8rem;
      font-weight: 500;
      font-family: "Poppins", sans-serif;
      cursor: pointer;
      user-select: none;
      background: rgba(121, 121, 133, 0.1);
      color: #0e2244;
      margin-top: 0.5rem;
      transition:
        background 0.15s,
        color 0.15s;

      &.clicked {
        background: var(--background-button-component, #0e2244);
        color: #fff;
      }
    }
  }

  .filter-select,
  .ant-select {
    width: 100%;
  }

  /* inline-flex do AntD cria gap extra por line-box; unifica altura raiz */
  .filter-select.ant-select-single,
  .filter-select-multi.ant-select-multiple {
    display: block !important;
    width: 100%;
    height: 2.5rem !important;
    min-height: 2.5rem !important;
    max-height: 2.5rem !important;
    margin: 0 !important;
    vertical-align: top;
  }

  .ant-select .ant-select-selector {
    min-height: 2.5rem !important;
    border-radius: 8px !important;
    border-color: rgba(14, 34, 68, 0.18) !important;
    display: flex !important;
    align-items: center !important;
    padding-inline: 11px !important;
  }

  .ant-select-single .ant-select-selector {
    height: 2.5rem !important;
  }

  .ant-select-single .ant-select-selection-item,
  .ant-select-single .ant-select-selection-placeholder {
    font-family: "Poppins", sans-serif !important;
    font-size: 0.85rem !important;
    line-height: 2.5rem !important;
    display: flex !important;
    align-items: center !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .ant-select-single .ant-select-selection-search-input {
    height: 2.5rem !important;
  }

  /* Multi (cidade/bairro/zona): mesma caixa e alinhamento dos selects simples */
  .filter-select-multi.ant-select-multiple .ant-select-selector {
    height: 2.5rem !important;
    min-height: 2.5rem !important;
    max-height: 2.5rem !important;
    overflow: hidden;
    padding-inline: 11px !important;
    padding-block: 0 !important;
  }

  .filter-select-multi.ant-select-multiple .ant-select-selector::after,
  .filter-select-multi.ant-select-multiple .ant-select-selection-wrap::after {
    display: none !important;
    margin: 0 !important;
    content: none !important;
  }

  .filter-select-multi.ant-select-multiple .ant-select-selection-wrap {
    align-self: center;
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
  }

  .filter-select-multi.ant-select-multiple .ant-select-selection-overflow {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    min-height: 22px;
    max-width: 100%;
    margin: 0 !important;
    padding: 0 !important;
  }

  .filter-select-multi.ant-select-multiple .ant-select-selection-overflow-item {
    align-self: center;
    margin: 0 !important;
  }

  .filter-select-multi.ant-select-multiple
    .ant-select-selection-overflow-item-suffix {
    align-self: center;
    min-height: 0 !important;
    margin: 0 !important;
  }

  /* AntD multi adiciona margin-inline-start no search/placeholder — remove o offset */
  .filter-select-multi.ant-select-multiple .ant-select-selection-search {
    margin-inline-start: 0 !important;
    margin-inline-end: 0 !important;
    margin-block: 0 !important;
    padding: 0 !important;
    max-width: 100%;
  }

  .filter-select-multi.ant-select-multiple .ant-select-selection-search-input {
    height: 22px !important;
    min-height: 22px !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .filter-select-multi.ant-select-multiple .ant-select-selection-item {
    height: 22px !important;
    line-height: 20px !important;
    margin-block: 0 !important;
    margin-inline-start: 0 !important;
    margin-inline-end: 4px !important;
    padding-inline: 6px !important;
    border-radius: 6px !important;
    display: inline-flex !important;
    align-items: center !important;
    font-family: "Poppins", sans-serif !important;
    font-size: 0.8rem !important;
    background: rgba(14, 34, 68, 0.08) !important;
    border: none !important;
  }

  .filter-select-multi.ant-select-multiple .ant-select-selection-item-content {
    margin-inline-end: 2px;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .filter-select-multi.ant-select-multiple .ant-select-selection-placeholder {
    inset-inline-start: 0 !important;
    inset-inline-end: 24px !important;
    left: 0 !important;
    right: 24px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    font-family: "Poppins", sans-serif !important;
    font-size: 0.85rem !important;
    line-height: 1.2 !important;
    margin: 0 !important;
    padding: 0 !important;
    color: rgba(0, 0, 0, 0.35) !important;
    display: block !important;
  }

  .ant-select-selection-placeholder {
    color: rgba(0, 0, 0, 0.35) !important;
  }
`;
